import { render, staticRenderFns } from "./MotivosComprasOportunidade.vue?vue&type=template&id=0410a26c"
import script from "./MotivosComprasOportunidade.vue?vue&type=script&lang=js"
export * from "./MotivosComprasOportunidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports